import React from 'react';

const ModalBody = (props) => {
    return (
        <div className="modal_body">
          {props.children}
         </div>
    );
};
export default ModalBody;